var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({domProps:{"textContent":_vm._s(_vm.icon)}},'v-icon',attrs,false),on))]}}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }